// 2020
export const avisospriv2020 = [
  {
    id: 1,
    titulo: "Constitución y Registro de Partidos Políticos Locales",
    simplificado: "1.pdf",
    integral: "2.pdf",
    corto: "3.pdf",
  },
  {
    id: 2,
    titulo: "Red de Candidatas PELO 2020-2021",
    simplificado: "4.pdf",
    integral: "5.pdf",
  },
  {
    id: 3,
    titulo: "Acreditación de medios de comunicación",
    simplificado: "6.pdf",
    integral: "7.pdf",
    corto: "8.pdf",
  },
  {
    id: 4,
    titulo: "Cuestionario sobre condiciones de salud",
    simplificado: "9.pdf",
    integral: "10.pdf",
    corto: "11.pdf",
  },
  {
    id: 5,
    titulo: "Entradas y Salidas",
    simplificado: "12.pdf",
    integral: "13.pdf",
    corto: "14.pdf",
  },
  {
    id: 6,
    titulo: "Eventos y Concursos",
    simplificado: "15.pdf",
    integral: "16.pdf",
    corto: "17.pdf",
  },
  {
    id: 7,
    titulo: "Filtro Sanitario",
    simplificado: "18.pdf",
    integral: "19.pdf",
    corto: "20.pdf",
  },
  {
    id: 8,
    titulo: "Archivo Fotográfico",
    simplificado: "21.pdf",
    integral: "22.pdf",
    corto: "23.pdf",
  },
  {
    id: 9,
    titulo: "Integración de Consejos Distritales y Municipales PELO 2020-2021",
    simplificado: "24.pdf",
    integral: "25.pdf",
    corto: "26.pdf",
  },
  {
    id: 10,
    titulo: "Procedimientos y solicitudes",
    simplificado: "27.pdf",
    integral: "28.pdf",
    corto: "29.pdf",
  },
  {
    id: 11,
    titulo: "Recursos Humanos",
    simplificado: "30.pdf",
    integral: "31.pdf",
    corto: "32.pdf",
  },
  {
    id: 12,
    titulo:
      "Registro de Candidaturas para el Proceso Electoral Local Ordinario 2020-2021",
    simplificado: "33.pdf",
    integral: "34.pdf",
    corto: "35.pdf",
  },
  {
    id: 13,
    titulo: "Servicios de capacitación",
    simplificado: "36.pdf",
    integral: "37.pdf",
    corto: "38.pdf",
  },
  {
    id: 14,
    titulo: "Trámites y procedimientos administrativos",
    simplificado: "39.pdf",
    integral: "40.pdf",
    corto: "41.pdf",
  },
  {
    id: 15,
    titulo: "Red de Mujeres Electas",
    simplificado: "42.pdf",
    integral: "43.pdf",
    corto: "44.pdf",
  },
];



// 2024
export const avisospriv2021 = [
  {
    id: 16,
    titulo: "Registro de Candidaturas PELE 2021",
    simplificado: "45.pdf",
    integral: "46.pdf",
    corto: "47.pdf",
  },
];

export const avisospriv2022 = [
  {
    id: 17,
    titulo:
      "Consulta previa, libre e informada a las Comunidades que eligen autoridades por el sistema de usos y costumbres y a las indígenas en el Estado de Tlaxcala",
    simplificado: "48.pdf",
    integral: "49.pdf",
    corto: "50.pdf",
  },
];

export const avisospriv2023 = [
  {
    id: 18,
    titulo: "Directorio de Autoridades Electas en Tlaxcala",
    simplificado: "51.pdf",
    integral: "52.pdf",
    corto: "53.pdf",
  },
  {
    id: 19,
    titulo: "Procedimientos de Candidaturas Independientes PELO 2023-2024",
    simplificado: "54.pdf",
    integral: "55.pdf",
    corto: "56.pdf",
  },
  {
    id: 20,
    titulo:
      "Sistema de Candidatas y Candidatos Conóceles para el PELO 2023-2024",
    simplificado: "57.pdf",
    integral: "58.pdf",
  },
];

export const avisospriv2024 = [
  {
    id: 21,
    titulo:
      "Atención a mujeres posibles víctimas de Violencia Política contra las Mujeres en Razón de Género",
    simplificado: "59.pdf",
    integral: "60.pdf",
    corto: "61.pdf",
  },
  {
    id: 22,
    titulo: "Observadores Electorales PELE 2024",
    simplificado: "62.pdf",
    integral: "63.pdf",
    corto: "64.pdf",
  },
  {
    id: 23,
    titulo: "Sistema de Candidatas y Candidatos Conóceles PELE 2024",
    simplificado: "65.pdf",
    integral: "66.pdf",
    corto: "67.pdf",
  },
  {
    id: 24,
    titulo: "Registro de Candidaturas PELE 2024",
    simplificado: "68.pdf",
    integral: "69.pdf",
    corto: "70.pdf",
  },
  {
    id: 25,
    titulo:
      "Proceso de Selección y Designación de los Consejos Distritales para el Proceso Electoral Local Extraordinario 2024-2025.",
    simplificado: "71.pdf",
    integral: "72.pdf",
    corto: "73.pdf",
  },
];

export const avisospriv2025 = [
  {
    id: 26,
    titulo:
      "Proceso de Reclutamiento, Selección y Contratación y Recontratación de las figuras de Capacitador/a Asistente Electoral Local (CAEL) y Supervisor/a Electoral Local (SEL), para el Proceso Electoral Local Extraordinario 2024-2025.",
    simplificado: "74.pdf",
    integral: "75.pdf",
    corto: "76.pdf",
  },
  {
    id: 27,
    titulo: "Concurso de Debate Universitario ITE.",
    simplificado: "77.pdf",
    integral: "78.pdf",
    corto: "79.pdf",
  },
  {
    id: 28,
    titulo: "Red de Mujeres Juzgadoras PELE 2024-2025",
    simplificado: "80.pdf",
    integral: "81.pdf",
    corto: "82.pdf",
  },
  {
    id: 29,
    titulo:
      "Uso del Sistema “Candidatas y Candidatos Conóceles” y de la Versión Ejecutiva del Proceso Electoral Local Extraordinario para renovar los cargos del Poder Judicial, Tribunal de Justicia Administrativa y Tribunal de Conciliación y Arbitraje 2024-2025.",
    simplificado: "83.pdf",
    integral: "84.pdf",
    corto: "85.pdf",
  },
  {
    id: 30,
    titulo: "Convención estatal del décimo sexto parlamento infantil",
    simplificado: "86.pdf",
    integral: "87.pdf",
    corto: "88.pdf",
  },
  {
    id: 31,
    titulo: "Licitaciones Públicas",
    simplificado: "89.pdf",
    integral: "90.pdf",
    corto: "91.pdf",
  },
  {
    id: 32,
    titulo: "Expedientes del personal",
    simplificado: "92.pdf",
    integral: "93.pdf",
    corto: "94.pdf",
  },
  {
    id: 33,
    titulo:
      "Atención y sustanciación de las quejas y denuncias derivadas del proceso electoral local extraordinario, para renovar los cargos del poder judicial, tribunal de justicia administrativa y tribunal del conciliación y arbitraje 2024-2025. ",
    simplificado: "95.pdf",
    integral: "96.pdf",
    corto: "97.pdf",
  },
  {
    id: 34,
    titulo:
      "Acreditación de los medios de comunicación y periodistas para la cobertura de la Jornada Electoral del Proceso Electoral Local Extraordinario 2024-2025.",
    simplificado: "98.pdf",
    integral: "99.pdf",
    corto: "100.pdf",
  },
  {
    id: 35,
    titulo: "Gestión, seguridad y almacenamento de datos",
    simplificado: "101.pdf",
    integral: "102.pdf",
    corto: "103.pdf",
  },
  {
    id: 36,
    titulo: "Mecanismos de participación ciudadana",
    simplificado: "104.pdf",
    integral: "105.pdf",
    corto: "106.pdf",
  },
  {
    id: 37,
    titulo: "Trámites y procedimientos administrativos de este instituto",
    simplificado: "107.pdf",
    integral: "108.pdf",
    corto: "109.pdf",
  },
  {
    id: 38,
    titulo: "Atención y trámites de oficialía de partes",
    simplificado: "110.pdf",
    integral: "111.pdf",
    corto: "112.pdf",
  },

  {
    id: 39,
    titulo:
      "Funciones y atribuciones de la dirección de organización electoral, capacitación y educación cívica",
    simplificado: "110.pdf",
    integral: "111.pdf",
    corto: "112.pdf",
  },

  {
    id: 40,
    titulo: "Declaraciones de situación patrimonial y de intereses",
    simplificado: "113.pdf",
    integral: "114.pdf",
    corto: "115.pdf",
  },

  {
    id: 41,
    titulo: "Agenda Presidencia",
    simplificado: "116.pdf",
    integral: "117.pdf",
    corto: "118.pdf",
  },
  {
    id: 42,
    titulo: "Funciones y atribuciones de la secretaría ejecutiva",
    simplificado: "119.pdf",
    integral: "120.pdf",
    corto: "121.pdf",
  },
  {
    id: 43,
    titulo: "Procedimientos y solicitudes de información de este instituto",
    simplificado: "122.pdf",
    integral: "123.pdf",
    corto: "124.pdf",
  },

  {
    id: 44,
    titulo: "Trámite y Seguimiento Quejas y Denuncias.",
    simplificado: "149.pdf",
    integral: "150.pdf",
    corto: "151.pdf",
  },

  {
    id: 45,
    titulo: "Registro de entradas y salidas",
    simplificado: "125.pdf",
    integral: "126.pdf",
    corto: "127.pdf",
  },
  {
    id: 46,
    titulo:
      "Convocatoria de difusores oficiales de los resultados del sistema informático de cómputos para el PELEPJ.",
    simplificado: "128.pdf",
    integral: "129.pdf",
    corto: "130.pdf",
  },

  {
    id: 47,
    titulo:
      "Formato “Carta de derechos de la persona usuaria” para la implementación del Protocolo de actuación para la atención de Violencia Política contra las Mujeres en Razón de Género.",
    simplificado: "131.pdf",
    integral: "132.pdf",
    corto: "133.pdf",
  },
  {
    id: 48,
    titulo:
      "Formato “Cédula para la canalización” para la implementación del Protocolo de actuación para la atención de Violencia Política contra las Mujeres en Razón de Género.",
    simplificado: "134.pdf",
    integral: "135.pdf",
    corto: "136.pdf",
  },
  {
    id: 49,
    titulo:
      "Formato “Entrevista de atención de primer contacto a mujeres en situación de Violencia Política contra las Mujeres en Razón de Género”. ",
    simplificado: "137.pdf",
    integral: "138.pdf",
    corto: "139.pdf",
  },
  {
    id: 50,
    titulo:
      "Formato “Acta Circunstanciada de no aplicación del cuestionario de evaluación de riesgo para casos de Violencia Política contra las Mujeres en Razón de Género”. ",
    simplificado: "140.pdf",
    integral: "141.pdf",
    corto: "142.pdf",
  },
  {
    id: 51,
    titulo:
      "Formato “Plan de Seguridad” para la implementación del Protocolo de actuación para la atención de Violencia Política contra las Mujeres en Razón de Género. ",
    simplificado: "143.pdf",
    integral: "144.pdf",
    corto: "145.pdf",
  },
  {
    id: 52,
    titulo:
      "Formato de “Orientación telefónica en materia de Violencia Política contra las Mujeres en Razón de Género”. ",
    simplificado: "146.pdf",
    integral: "147.pdf",
    corto: "148.pdf",
  },
  {
    id: 53,
    titulo:
      "Eventos y concursos de este Instituto”. ",
    simplificado: "152.pdf",
    integral: "153.pdf",
    corto: "154.pdf",
  },
  {
    id: 54,
    titulo:
      "Estudio de la percepción de las juventudes tlaxcaltecas en los procesos electorales.”. ",
    simplificado: "155.pdf",
    integral: "156.pdf",
    corto: "157.pdf",
  },
];


export const avisospriv2026 = [
  {
    id: 55,
    titulo:
      "Aviso de Privacidad para la encuesta muestral del “Estudio de participación de la niñez y las adolescencias en Tlaxcala”",
    simplificado: "158.pdf",
    integral: "159.pdf",
    corto: "160.pdf",
  },

  {
    id: 56,
    titulo:
      "CUESTIONARIO PERSONAS CON DISCAPACIDAD",
    simplificado: "56.1.pdf",
    integral: "56.2.pdf",
    corto: "56.3.pdf",
  },
  {
    id: 57,
    titulo: "LISTAS DE ASISTENCIA",
    simplificado: "57.1.pdf",
    integral: "57.2.pdf",
    corto: "57.3.pdf",
  },
  {
    id: 58,
    titulo: "CONSULTA LGBT CUESTIONARIO",
    simplificado: "58.1.pdf",
    integral: "58.2.pdf",
    corto: "58.3.pdf",
  },
  {
    id: 59,
    titulo: "CONSULTA LGBT LISTAS DE ASISTENCIA",
    simplificado: "59.1.pdf",
    integral: "59.2.pdf",
    corto: "59.3.pdf",
  },
  {
    id: 60,
    titulo: "CONSULTA INDÍGENA",
    simplificado: "60.1.pdf",
    integral: "60.2.pdf",
    corto: "60.3.pdf",
  },
  {
    id: 61,
    titulo: "Solicitud de acreditación para participar como persona observadora",
    simplificado: "61.1.pdf",
    integral: "61.2.pdf",
    corto: "61.3.pdf",
  },
  /* {
    id: 62,
    titulo: "",
    simplificado: "62.1.pdf",
    integral: "62.2.pdf",
    corto: "62.3.pdf",
  },
  {
    id: 63,
    titulo: "",
    simplificado: "63.1.pdf",
    integral: "63.2.pdf",
    corto: "63.3.pdf",
  },
  {
    id: 64,
    titulo: "",
    simplificado: "64.1.pdf",
    integral: "64.2.pdf",
    corto: "64.3.pdf",
  },
  {
    id: 65,
    titulo: "",
    simplificado: "65.1.pdf",
    integral: "65.2.pdf",
    corto: "65.3.pdf",
  },
  {
    id: 66,
    titulo: "",
    simplificado: "66.1.pdf",
    integral: "66.2.pdf",
    corto: "66.3.pdf",
  },
  {
    id: 67,
    titulo: "",
    simplificado: "67.1.pdf",
    integral: "67.2.pdf",
    corto: "67.3.pdf",
  },
  {
    id: 68,
    titulo: "",
    simplificado: "68.1.pdf",
    integral: "68.2.pdf",
    corto: "68.3.pdf",
  },
  {
    id: 69,
    titulo: "",
    simplificado: "69.1.pdf",
    integral: "69.2.pdf",
    corto: "69.3.pdf",
  },
  {
    id: 70,
    titulo: "",
    simplificado: "70.1.pdf",
    integral: "70.2.pdf",
    corto: "70.3.pdf",
  }, */
  
];


export const dataAvisosPriv = [
  ...avisospriv2020,
  ...avisospriv2021,
  ...avisospriv2022,
  ...avisospriv2023,
  ...avisospriv2024,
  ...avisospriv2025,
  ...avisospriv2026,
];